import '../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import { N as Node, T as Text, a as Element } from '../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/index-B_A1dZu-.js';

const NodeUtils = {
  isElementNode(node) {
    return Element.isElement(node);
  },
  isTextNode(node) {
    return Text.isText(node);
  },
  isEmptyTextNode(node) {
    return this.isTextNode(node) && node.text.trim() === "";
  },
  createTextNode(text, decoration) {
    return { text, decoration };
  },
  getText(node) {
    return Node.string(node);
  },
  getNodeType(node) {
    if (this.isElementNode(node)) {
      return node.type || "";
    }
    return "";
  },
  checkNodeType(node, type) {
    return this.getNodeType(node) === type;
  },
  getChildrenByType(node, targetType) {
    const result = [];
    for (const child of node.children) {
      if (child.type === targetType) {
        result.push(child);
      }
    }
    return result;
  },
  getUnsetChildren(node) {
    let children = [];
    node.children.forEach((child) => {
      if (this.isElementNode(child)) {
        if (child.children && child.children.length > 0) {
          children = children.concat(this.getUnsetChildren(child));
        }
      } else {
        children.push(child);
      }
    });
    return children;
  }
};

export { NodeUtils };
//# sourceMappingURL=node-utils.js.map
